import { NotFound } from "./NotFound";
import { matchAppRoute } from "./routes";

export function App() {
  return matchAppRoute(location.pathname)?.render() ?? <NotFound/>;
}
